import { useState } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import type { Project } from '@y2/api-clients/yad1';
import { CheckMarkIcon } from '@y2/deprecated/ui/icons';

import styles from './project-in-your-area-item.module.scss';
import texts from './project-in-your-area-item.texts.json';
import { RoundButton } from '../../../components/round-button/round-button';

type ProjectInYourAreaItemProps = {
  project: Project;
  onClick: () => void;
};

export function ProjectInYourAreaItem({
  project,
  onClick,
}: ProjectInYourAreaItemProps) {
  const [isLeadSent, setIsLeadSent] = useState(false);

  const handleClick = () => {
    onClick();
    setIsLeadSent(true);
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageBox}>
        <Image src={project.mainImage} alt={project.projectName} fill />
      </div>
      <div className={styles.content}>
        <span className={styles.name}>{project.projectName}</span>
        <span className={styles.address}>{project.address}</span>
        <span className={styles.promotion}>{project.promotionalLabel}</span>
      </div>
      <RoundButton
        className={cn(styles.button, isLeadSent && styles.leadSent)}
        onClick={handleClick}
      >
        {isLeadSent && <CheckMarkIcon className={styles.icon} />}
        {isLeadSent ? texts.detailsSent : texts.iWantMoreInfo}
      </RoundButton>
    </div>
  );
}
